export default "__VITE_ASSET__b3424440__"